import Vue from 'vue'
import VueRouter from 'vue-router'
import AdminRoutes from './admin/index'
import AuthRoutes from './auth'
import Dashboard from './dashboard'
import Error404 from '../views/Errors/Error404';
import Home from '../views/Home';
import i18n from '../plugins/i18n'

Vue.use(VueRouter)

const HomeRoute = {path: '/', name: 'Home',     component: Home,     meta: {layout: 'default', forAll: true, title: 'Home'}};
const ErrorRoute = {path: '*', name: 'Error404', component: Error404, meta: {layout: 'default', forAll: true, title: '404'}};

const i18nRoutes = [
    { path: '/', redirect: `/${i18n.locale}` },

    {   path: '/:lang(en|am)',
        component: { render(c) { return c('router-view') } },
        children: [
            ...AuthRoutes,
            ...Dashboard,
            HomeRoute,
            ErrorRoute
        ]
    }
]

const ROUTES = [
    ...i18nRoutes,
    ...AdminRoutes
];

const router = new VueRouter({
  mode: 'history',
  base: '/education',
  routes: ROUTES
})

router.beforeEach((to, from, next) => {
    document.title = process.env.VUE_APP_NAME + `${to.meta.title ? ' - ' + to.meta.title : ''}`;
    if(to.meta.forAll) return next();

    let requiresAuth  = to.meta.requiresAuth;
    let isAdmin       = to.meta.is_admin;
    let homeToken     = localStorage.getItem('home_token');
    let adminToken    = localStorage.getItem('admin_token');

    if(!isAdmin) {
        if(requiresAuth && homeToken === null) next({name : 'Login'});
        else if(!requiresAuth && homeToken !== null) next({name : 'Blog'});
        else next();
    } else {
        if(requiresAuth && adminToken === null) next({name : 'AdminLogin'});
        else if(!requiresAuth && adminToken !== null) next({name : 'AdminBlog'});
        else next();
    }
})

router.beforeEach((to, from, next) => {
    let language = to.params.lang;

    if (!language) {
        language = 'en'
    }

    i18n.locale = language
    next()
})

export default router
